import { abbrmonthNames, enumAutoTextType, enumLanguage, monthNames } from "../constants";
import { appstr } from "../utils/appstr";
import { getReadableStringFromDateAndTime } from "../utils/getReadableStringFromDateAndTime";
import { SmartGetFieldValue } from "../utils/SmartGetFieldValue";

export class QAutoTextMgr {
  constructor() {
    this.fDoc = null;
    this.fOrgInfo = null;
  }

  InitAutoTextMgr(theDoc) {
    this.fDoc = theDoc;
    var orgInfo = theDoc.GetDocMgr().fWSMgr.GetOrgInfo();
    this.fOrgInfo = orgInfo;
  }

  GetRefreshDate(includeTime, customDateFormat, includeLabel = true) {
    var oi = this.fOrgInfo;
    var docMgr = this.fDoc.GetDocMgr();
    var refreshDate = docMgr.GetRefreshDate(); //yyyymmdd
    var refreshTime = docMgr.GetRefreshTime(); //hhmm
    var dateFormat = customDateFormat ? customDateFormat : oi.GetDateFormat();
    var timeFormat = oi.GetTimeFormat();
    if (refreshDate == null) return "???";

    return getReadableStringFromDateAndTime(
      refreshDate,
      refreshTime,
      dateFormat,
      timeFormat,
      includeTime,
      includeLabel
    );
  }

  GetTimeStamp(dateFormat) {
    return this.GetRefreshDate(true, dateFormat, true);
  }

  GetRefreshDateLabel(dateFormat) {
    return this.GetRefreshDate(false, dateFormat, true);
  }

  GetRefreshDateValue() {
    var dateFormat = this.fOrgInfo.GetDateFormat();
    return this.GetRefreshDate(true, dateFormat, false);
  }

  GetCurrentDate() {
    var dateFormat = this.fOrgInfo.GetDateFormat();

    var currentTime = new Date();
    var dateString = currentTime.FormatDate(dateFormat);
    /*
    switch (dateFormat)
    {
        case 0: // "January 28, 2016"
           dateString = appstr(monthNames[month]) + " " + day + ", " + year;
           break;
        case 1: // "28 January 2016" (in French - 28 janvier 2016)
           var cLanguage = GetCurrentLanguage();
             if (cLanguage != enumLanguage.english)
                  dateString = day + " " + appstr(monthNames[month]).toLowerCase() + " " + year;
             else
                  dateString = day + " " + appstr(monthNames[month]) + " " + year;
             break;
        case 2: // "28 Jan 2016"
           dateString = day + " " + appstr(abbrmonthNames[month]) + " " + year;
           break;
          case 3: // "01/28/2016"
             dateString = monthS + "/" + day + "/" + year;
             break;
          case 4: // "01-28-2016"
             dateString = monthS + "-" + day + "-" + year;
             break;
          case 5: // "01.28.2016"
             dateString = monthS + "." + day + "." + year;
             break;
          case 6: // "01/28/16"
             dateString = monthS + "/" + day + "/" + year.toString().substr(2,2);
             break;
          case 7: // "01-28-16"
             dateString = monthS + "-" + day + "-" + year.toString().substr(2,2);
             break;
          case 8: // "01.28.16"
             dateString = monthS + "." + day + "." + year.toString().substr(2,2);
             break;
          case 9: // "28/01/2016"
             dateString = day + "/" + monthS + "/" + year;
             break;
          case 10: // "28-01-2016"
             dateString = day + "-" + monthS + "-" + year;
             break;
          case 11: // "28.01.2016""
             dateString = day + "." + monthS + "." + year;
             break;
          case 12: // "28/01/16"
             dateString = day + "/" + monthS + "/" + year.toString().substr(2,2);
             break;
          case 13: // "28-01-16"
             dateString = day + "-" + monthS + "-" + year.toString().substr(2,2);
             break;
          case 14: // "28.01.16"
             dateString = day + "." + monthS  + "." + year.toString().substr(2,2);
             break;
          case 15: // "01-2016"
             dateString = monthS  + "-" + year;
             break;
          case 16: // "January 2016"
             dateString = appstr(monthNames[month]) + " " + year;
             break;
          case 17: //  "January-2016"
             dateString = appstr(monthNames[month]) + "-" + year;
             break;
          case 18: //  "28 (day)"
             dateString = day;
             break;
          case 19: //  "January"
             dateString =  appstr(monthNames[month]); //
             break;
          case 20: // "2016 (year)"
             dateString = year;
             break;
    }
      */

    return dateString;
  }

  GetSubChartMgr() {
    var theDoc = this.fDoc;
    if (theDoc == null) return null;

    return theDoc.GetSubChartMgr();
  }

  GetAutoTextValue(autoTextType) {
    var s;
    var scm = this.GetSubChartMgr();
    var d = this.fDoc;

    switch (autoTextType) {
      case enumAutoTextType.pagenum:
        s = scm.GetActivePageNumber();
        break;
      case enumAutoTextType.totalpages:
        s = scm.GetNumSubCharts();
        break;
      case enumAutoTextType.pagex:
        return appstr("Page") + " " + scm.GetActivePageNumber();
        break;
      case enumAutoTextType.pagexofy:
        return (
          appstr("Page") +
          " " +
          scm.GetActivePageNumber() +
          " " +
          appstr("of") +
          " " +
          scm.GetActiveBranchPages()
        );
        break;
      case enumAutoTextType.currentdate:
        return this.GetCurrentDate();
        break;
      case enumAutoTextType.subchartname:
        s = scm.GetActiveSubChartName();
        break;
      case enumAutoTextType.subchartnum:
        s = appstr("subchartnum") + scm.GetActiveSubChartNum();
        break;
      case enumAutoTextType.subchartpath:
        s = scm.GetActiveSubChartPath(false);
        break;
      case enumAutoTextType.chainofcmd:
        s = scm.GetChainOfCommand();
        break;
      case enumAutoTextType.division:
        s = d.GetDivisionName();
        if (s == null) {
          var curSC = scm.GetActiveSubChart();
          if (curSC) {
            var topObj = curSC.GetTopDBObj();
            if (topObj) s = topObj.SmartGetFieldValue("Division");
          }
        }
        if (s == null) s = appstr("Division");
        break;
      case enumAutoTextType.filename:
        var docMgr = this.fDoc.GetDocMgr();
        var s = docMgr.GetFileName(false);
        if (s.length == 0) s = appstr("Untitled");
        break;
      case enumAutoTextType.companyname:
        var s = this.fOrgInfo.GetOrgName();
        break;
      case enumAutoTextType.refreshdate:
        return this.GetRefreshDateLabel();
        break;
      case enumAutoTextType.refreshtime:
        return this.GetTimeStamp();
        break;
    }

    return s;
  }
}
